export var ApplePayRecurringPaymentDateUnitObj = ["year", "month", "day", "hour", "minute"];
/** @internal */
export var validateApplePayRecurringPaymentDateUnit = function (applePayRecurringPaymentDateUnit) { return ApplePayRecurringPaymentDateUnitObj.includes(applePayRecurringPaymentDateUnit); };
